






























































import { Component, Vue, PropSync } from "vue-property-decorator";
import { actions, getters, mutations } from "@/observables";
import moment from "moment";

@Component({})
export default class STForm extends Vue {
  /* Data */
  equipmentLoading = false;
  cancelLoading = false;
  equipmentErrors = [] as Array<TenderDispath.ErrosDispatch>;
  tenderSelected = this.equipmentTDSelected;
  oldDispatch = {} as TenderDispath.TenderDispath;
  valid = true;
  lazy = false;
  rules = [
    (v: any) => !!v || this.$t("notification.fieldRequired"),
    (v: number | any[]) => (v && v > 0) || this.$t("notification.lessThanZero")
  ]; // rules para os inputs de codigo (required e menor que zero)
  // tenderDispath = {} as TenderDispath.TenderDispath;
  @PropSync("tender") tenderDispath!: TenderDispath.TenderDispath;
  @PropSync("canSend") canSendTender!: boolean;

  /* Computed */
  get warehouses() {
    return getters.getWarehouses();
  }

  get equipments() {
    return getters.getEquipments();
  }

  get equipmentTDSelected() {
    return getters.getTDEquipmentSelected();
  }

  /* methods */
  onChangeWarehouse() {
    mutations.setTDWarehouseSelected(this.tenderDispath.wareHouse);
  }

  async onChangeEquipment(tender: Tender.Equipamento) {
    mutations.setTDEquipmentSelected(tender);
    const equipment = this.equipmentTDSelected;
    this.equipmentLoading = true;
    this.canSendTender = true;
    this.equipmentErrors = [];
    try {
      const response = await actions.checkTenderIsBusy(equipment.cdTenderTruck);
      console.log("response", response);
      if (response?.length) {
        if (response.includes("TENDER_BUSY_WITH_DISPATCH")) {
          this.oldDispatch = await actions.getDispatch(equipment.cdTenderTruck);
        }
        this.showMessage(response);
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.equipmentLoading = false;
    }
  }

  showMessage(exceptionsReceived: string[]) {
    // Lista disponivel de exeções para quando o tender esta ocupado
    const exceptions = [
      {
        key: "TENDER_BUSY_WITH_TRIP",
        text:
          "The tender is traveling with a trip at that moment, you will not be able to send until it is canceled or completed.",
        subText: "",
        cancelBtn: false,
        canSend: false
      },
      {
        key: "TENDER_BUSY_WITH_DISPATCH",
        text: "The tender has an active dispatch, if you send it will be canceled and replaced.",
        subText: this.getInfoDispatch(),
        cancelBtn: true,
        canSend: true
      }
    ];
    this.equipmentErrors = exceptions.filter(e => exceptionsReceived.includes(e.key));

    if (this.equipmentErrors.length) {
      this.equipmentErrors.forEach(m => {
        if (!m.canSend) {
          this.canSendTender = false;
        }
      });
    }
  }

  formatDate(date: string) {
    return moment(date).format("YYYY-MM-DD HH:mm");
  }

  getInfoDispatch() {
    return this.oldDispatch && this.oldDispatch.id
      ? `Created at ${this.formatDate(this.oldDispatch.createdAt)} to warehouse ${this.oldDispatch.wareHouse.descLocal}`
      : "";
  }

  async cancelDispatch() {
    this.cancelLoading = true;
    const equipment = this.equipmentTDSelected;
    try {
      await actions.changeStatusDispatch(this.oldDispatch.id, "VOID");
      await this.onChangeEquipment(equipment);
    } catch (e) {
      console.error(e);
    } finally {
      this.cancelLoading = false;
    }
  }
}
